export default __webpack_public_path__ + "static/media/Guía de Uso del Sistema de Gestión de Expedientes.053e0ffc.pdf";